export const ROOM_DND_TYPE = "ROW";
export const PINNED_ROOMS_MAX = 10;

export function roomIdsMatch(a, b) {
  return a != null && b != null && String(a) === String(b);
}

export function findRoomInLists(roomId, projects, internalProjectsAll) {
  if (roomId == null) return null;
  const fromExternal = (projects || []).find((p) => roomIdsMatch(p.id, roomId));
  if (fromExternal) return fromExternal;
  for (const company of internalProjectsAll || []) {
    const list = company.userProjectList || [];
    const found = list.find((p) => roomIdsMatch(p.id, roomId));
    if (found) return { ...found, isInternal: true };
  }
  return null;
}

export function resolvePinnedRoom(pin, projects, internalProjectsAll) {
  const full = findRoomInLists(pin && pin.id, projects, internalProjectsAll);
  if (full) {
    return { ...full, isOpened: true, key: full.key || full.id };
  }
  return {
    ...pin,
    isJoin: pin.isJoin !== undefined ? pin.isJoin : true,
    isOpened: true,
    key: pin.id,
  };
}

export function roomUnreadCount(room, showDailyBriefingCounters) {
  if (!room) return 0;
  return (
    (Number(room.unseenBuildingChat) || 0) +
    (showDailyBriefingCounters ? Number(room.unseenDailyBriefingCount) || 0 : 0)
  );
}

/**
 * Drop a just-opened room chat's unread from the project lists the SideNav
 * pin badge reads. Without this, `unseenBuildingChat` stays at N until reload.
 */
export function decrementRoomUnreadInLists(projects, internalProjectsAll, roomId, unreadCount) {
  const unread = Number(unreadCount) || 0;
  if (roomId == null || unread <= 0) {
    return { projects, internalProjectsAll, changed: false };
  }
  // unseenBuildingChat is a count of unread chat threads, not messages.
  const drop = 1;
  let changed = false;
  let nextProjects = projects;
  const extIdx = (projects || []).findIndex((p) => roomIdsMatch(p && p.id, roomId));
  if (extIdx !== -1) {
    nextProjects = [...projects];
    const prev = Number(nextProjects[extIdx].unseenBuildingChat) || 0;
    nextProjects[extIdx] = {
      ...nextProjects[extIdx],
      unseenBuildingChat: Math.max(0, prev - drop),
    };
    changed = true;
  }
  const nextInternal = (internalProjectsAll || []).map((company) => {
    const list = company.userProjectList || [];
    const idx = list.findIndex((p) => roomIdsMatch(p && p.id, roomId));
    if (idx === -1) return company;
    changed = true;
    const nextList = [...list];
    const prev = Number(nextList[idx].unseenBuildingChat) || 0;
    nextList[idx] = {
      ...nextList[idx],
      unseenBuildingChat: Math.max(0, prev - drop),
    };
    const prevTotal = Number(company.totalUnreadChat) || 0;
    return {
      ...company,
      userProjectList: nextList,
      totalUnreadChat: Math.max(0, prevTotal - drop),
    };
  });
  return {
    projects: nextProjects,
    internalProjectsAll: nextInternal,
    changed,
  };
}
